import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { TECHNICAL_SHEET_ROUTE } from '../types/technical-sheet-route.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for Roteiro da Ficha Técnica (Technical Sheet Route).
 * Subcollection: org/{orgId}/technical-sheet/{technicalSheetId}/route
 *
 * Resolve repository with context: { orgId, technicalSheetId }.
 */
export const technicalSheetRouteDescriptor = {
    name: TECHNICAL_SHEET_ROUTE,
    label: 'Roteiro da Ficha Técnica',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/technical-sheet/{technicalSheetId}/route',
    pathPatternKeys: {
        orgId: 'string',
        technicalSheetId: 'string',
    },
    version: 1,
    description: 'Processo, ordem e instruções por etapa do roteiro',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        // NoCache: filho de entidade versionada (spec 0045) — itens em cache voltariam velhos após Recarregar e seriam regravados por cima.
        cache: CacheStrategy.NoCache,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique route step identifier',
        },
        {
            name: 'processId',
            label: 'Processo vinculado',
            type: 'string',
            required: true,
            description: 'Reference to the process for this step',
        },
        {
            name: 'order',
            label: 'Ordem',
            type: 'number',
            required: true,
            description: 'Execution order (1-based)',
        },
        {
            name: 'processInstructions',
            label: 'Instruções de processo',
            type: 'string',
            required: false,
            maxLength: FIELD_LIMITS.DESCRIPTION,
            description: 'Process instructions for this step',
        },
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [
        {
            fieldName: 'processId',
            targetEntity: 'Process',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Processo vinculado ao passo do roteiro',
        },
        ...AUDIT_FOREIGN_KEYS,
    ],
};
//# sourceMappingURL=technical-sheet-route.descriptor.js.map